import type { ITagProps } from "@fluidattacks/design";
import { Tag } from "@fluidattacks/design";
import capitalize from "lodash/capitalize";

const getTagProps = (
  value: string,
): { icon: ITagProps["icon"]; variant: ITagProps["variant"] } => {
  if (value === "Approved") {
    return { icon: "check-circle", variant: "success" };
  } else if (value === "Rejected") {
    return { icon: "xmark-circle", variant: "error" };
  } else if (value === "Requested") {
    return { icon: "circle-arrow-up", variant: "warning" };
  }

  return { icon: "ban", variant: "inactive" };
};

const statusFormatter = (value: string): JSX.Element => {
  const tagValue = value === "SUBMITTED" ? "Requested" : capitalize(value);
  const { icon, variant } = getTagProps(tagValue);

  return (
    <Tag
      icon={icon}
      priority={variant === "inactive" ? "default" : "low"}
      tagLabel={tagValue.split(" ")[0]}
      variant={variant}
    />
  );
};

export { statusFormatter };
